// import React, { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
// import LoadingScreen from "./components/LoadingScreen";
import Projects from "./components/Projects";
import About from "./components/About";
// import Contact from "./components/Contact";
import FloatingContact from "./components/FloatingContact";
import Footer from "./components/Footer"; 

function App() {
  // const [loading, setLoading] = useState(true);

  return (
    <div className="relative font-sans geometric-bg">
      {/* Main Content */}
      <div className="relative z-10">
        {/* {loading ? (
          <LoadingScreen onComplete={() => setLoading(false)} />
        ) : ( */}
          <>
            <Navbar />
            <Hero />
            <About />
            <Projects />
            <Footer />
            <FloatingContact />
          </>
        {/* )} */}
      </div>
    </div>
  );
}

export default App;
